import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const ContactsPage = () => {
    const fileName = 'Contacts';
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const columns = [

        {
            Header: "Contact ID",
            accessor: "ContactNumberID",
            filter: "ContactsID",
            sortType: "basic",
            width:100
        },
        {
            Header: "Contact Name ",
            accessor: "ContactName",
            filter: "ContactName",
            sortType: "basic",
            width:200
        },{
            Header: "Email ID",
            accessor: "Email",
            filter: "Email",
            sortType: "basic",
            width:230
        },
        {
            Header: "Address",
            accessor: "AddressLine1",
            filter: "AddressLine1",
            sortType: "basic",
        }, {
            Header: "City ",
            accessor: "City",
            filter: "City",
            sortType: "basic",
        }, {
            Header: "State",
            accessor: "State",
            filter: "State",
            sortType: "basic",
            width:80
        },
        {
            Header: "Country ",
            accessor: "Country",
            filter: "Country",
            sortType: "basic",
            width:100
        },
        {
            Header: "Zip Code",
            accessor: "ZipCode",
            filter: "ZipCode",
            sortType: "basic",
            width:100
        },
        {
            Header: "Created Date ",
            accessor: "CreatedOn",
            filter: "CreatedOn",
            sortType: "basic",
            width:110,
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
  
    ];
   
    useEffect(() => {
        getContacts();
    }, []);
    async function getContacts() {
        setLoading(true);
        if(!localStorage.getItem("contacts")) {
        await _HttpServices
            .getData("Api/Inbound/Contacts")
            .then((data) => {
                const contactResult = data.data;
                if (contactResult.length > 0) {
                    contactResult.map((res) => {
                        res.CreatedOn = moment(res.CreatedOn).format('MM/DD/YYYY')
                        console.log(res.CreatedOn)
                    })
                }
                setContacts(contactResult);
                localStorage.setItem("contacts",JSON.stringify(contactResult))
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                setHasError(true);
            });
        } else  {
            let contact = localStorage.getItem("contacts")
            if(contact === null) {
                contact = []
            }
            setContacts(JSON.parse(contact));
            setLoading(false)
        }
    }




   
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Contacts</h2>
                {loading ? <Loader /> : null}
                {contacts.length > 0 ?
                <Button type="submit" onClick={() => getExcel(columns,contacts,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button>
                    : null}
                </div>
            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4" hidden={true}>
                        <div className="card-body">
                            <Form>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="StartDate">
                                                    Since
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="EndDate">
                                                    Until
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mt-1">
                                            <Button type="submit" className="mt-4" disabled><IoMdDoneAll className="icon btn-icon" />Submit</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>

                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load contacts.</p> :
                                <Fragment>
                                    {contacts.length > 0 ? (
                                        <ReactTable columns={columns} data={contacts} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                             }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Footer />
        </section>
    );
}
export default ContactsPage;